import React, { Component } from 'react';

export default class extends Component {
    state = {
        q: null
    };

    buscar = (e) => {
        e.preventDefault();
        document.location = `/#/buscar?q=${this.state.q}`;
    };

    render = () => {
        return (
            <form onSubmit={this.buscar} className='buscar form-inline'>
                <input type='text' id={this.props.nombre}
                       name='q'
                       onChange={(e) => this.setState({ q: e.target.value })}
                       className='form-control'/>
                <button className='btn'><span className='glyphicon glyphicon-search'/></button>
            </form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FormBuscar.js